import { axiosInstance } from '@repo/ui/lib/api/axios-instance';

export const PAYMENT_DEBUG_SECRET_STORAGE_KEY = 'payment_lifecycle_debug_secret';

const DEBUG_SECRET_HEADER = 'X-Debug-Secret';

function debugHeaders(secret: string): Record<string, string> {
  return { [DEBUG_SECRET_HEADER]: secret };
}

/** Vérifie le mot de passe root côté API (sans exposer le secret dans le frontend). */
export async function verifyPaymentDebugSecret(password: string): Promise<void> {
  await axiosInstance.post('/payments/debug/verify', { password });
}

export interface PaymentLifecycleStatus {
  groupeId: number;
  planType: string | null;
  subscriptionStatus: string | null;
  paymentFailedAt: string | null;
  suspendedAt: string | null;
  paymentWarningSentAt: string | null;
  deletionWarningSentAt: string | null;
  customerId: string | null;
  subId: string | null;
  dateEcheance: string | null;
}

export async function fetchPaymentLifecycleStatus(
  groupeId: number,
  debugSecret: string,
): Promise<PaymentLifecycleStatus> {
  const { data } = await axiosInstance.get<{ data: PaymentLifecycleStatus }>(
    `/payments/debug/status/${groupeId}`,
    { headers: debugHeaders(debugSecret) },
  );
  return data.data;
}

export async function simulatePaymentFailure(
  groupeId: number,
  debugSecret: string,
): Promise<PaymentLifecycleStatus> {
  const { data } = await axiosInstance.post<{ data: PaymentLifecycleStatus }>(
    `/payments/debug/simulate-payment-failure/${groupeId}`,
    {},
    { headers: debugHeaders(debugSecret) },
  );
  return data.data;
}

export async function advancePaymentLifecycleTime(
  groupeId: number,
  debugSecret: string,
  payload: { paymentFailedDaysAgo?: number; suspendedDaysAgo?: number },
): Promise<PaymentLifecycleStatus> {
  const { data } = await axiosInstance.post<{ data: PaymentLifecycleStatus }>(
    `/payments/debug/advance-time/${groupeId}`,
    payload,
    { headers: debugHeaders(debugSecret) },
  );
  return data.data;
}

export async function runPaymentLifecycleCron(
  step: 'suspend' | 'deletion-warning' | 'delete',
  debugSecret: string,
): Promise<{ step: string; message: string }> {
  const { data } = await axiosInstance.post<{ step: string; message: string }>(
    `/payments/debug/run-cron/${step}`,
    {},
    { headers: debugHeaders(debugSecret) },
  );
  return data;
}

export async function resetPaymentLifecycle(
  groupeId: number,
  debugSecret: string,
): Promise<PaymentLifecycleStatus> {
  const { data } = await axiosInstance.post<{ data: PaymentLifecycleStatus }>(
    `/payments/debug/reset/${groupeId}`,
    {},
    { headers: debugHeaders(debugSecret) },
  );
  return data.data;
}
